export default function refreshAt(hours, minutes, seconds, jitterMinutes = 0) {
  const now = new Date();
  const then = new Date();

  // Add random jitter within the specified window
  const jitterMs = Math.floor(Math.random() * jitterMinutes * 60 * 1000);
  const jitteredMinutes = minutes + Math.floor(jitterMs / (60 * 1000));
  const jitteredSeconds = Math.floor((jitterMs % (60 * 1000)) / 1000);

  /*eslint-disable */
  if (now.getHours() > hours ||
     (now.getHours() === hours && now.getMinutes() > jitteredMinutes) ||
      now.getHours() === hours && now.getMinutes() === jitteredMinutes && now.getSeconds() >= jitteredSeconds) {
    then.setDate(now.getDate() + 1);
  }
  /*eslint-enable */

  then.setHours(hours);
  then.setMinutes(jitteredMinutes);
  then.setSeconds(jitteredSeconds);

  const timeout = (then.getTime() - now.getTime());

  console.log(`Will reload at ${hours}:${jitteredMinutes.toString().padStart(2, '0')}:${jitteredSeconds.toString().padStart(2, '0')} (jittered from ${hours}:${minutes}:${seconds}) which is in ${timeout} ms`);

  setTimeout(() => window.location.reload(true), timeout);
}
